﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { IConnector } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { SpaceNode } from '../meshes/space-node';
import { Token } from '../token';
import { BaseConnector } from './base-connector';

@Kb3dModel({
    token: Token.Connector,
})
export class Connector extends BaseConnector implements IConnector {
    /** override base parent for more specific typing*/
    public _parent: SpaceNode | undefined;

    public getAncestors() {
        return super.getAncestors() as SpaceNode[];
    }

    public getSpaceParent() {
        return this._parent;
    }
}

export function isConnector(o: Kb3dObject): o is Connector {
    return instanceOf(o, Token.Connector);
}
